// @ts-nocheck
import { icon } from "~/util/dom";
import { _ } from "~/i18n";
import { ROUTE_CONST } from "~/route/const";
import { replaceOldCriterion } from "~/route/utils";
import { getIcon } from "~/util/providers/poiagg";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import createSDSIcon from "~/ui/icon";
import { activityTypeToMapIcon, pathTypeToMapIcon, routeTypeToMapIcon } from "~/scene/common/icons";

export interface IImageData {
	icon: boolean;
	img: () => HTMLImageElement;
	imgSrc: string;
	svg: () => SVGElement;
	svgName: string;
	customDesc: string;
}

/**
 * Pozadi itemu nebo slozky.
 *
 * @param {Object} data Vstupni data
 * @return {String}
 */
export function getImageData(data): IImageData {
	const imageData = {
		icon: false,
		img: null,
		imgSrc: "",
		svg: null,
		svgName: "",
		customDesc: "",
	};

	// obrazek z dat
	if (data.img) {
		imageData.imgSrc = Mapy.CDN.setSize(data.img, Mapy.CDN.SIZE_80_52);
	}

	// podle typu bude obrazek ci ikona
	let type = data.type;

	if (type === "measure" && data.data?.readonly) {
		type = "measureRO";
	}

	switch (type) {
		case "folder":
			if (imageData.imgSrc === "") {
				imageData.imgSrc = "/img/mymap/folder-placeholder.png";
			}
			break;

		// ikona
		case "entity":
			if (data.poi_type_id && imageData.imgSrc === "") {
				imageData.icon = true;
				imageData.imgSrc = getIcon(data.poi_type_id, {
					scale: 2,
				});
			} else {
				imageData.svgName = "star-line";
			}
			break;

		case "point":
			imageData.svgName = "star-line";
			break;

		case "link":
			switch (data.linktype) {
				case "photo":
					imageData.svgName = "image";
					break;

				case "track":
				default:
					if (data.data) {
						imageData.svg = () => createSDSIcon({ symbol: activityTypeToMapIcon(data?.data?.type) });
						imageData.svgName = "star-line";

						if (data.data.totalLength && data.data.totalTime) {
							const distance = standardDistanceFormat(data.data.totalLength);
							const time = standardTimeFormat(data.data.totalTime, false);

							imageData.customDesc = _("mymap.places.activity", {
								DIST: `${distance.string}`,
								TIME: time.string,
							});
						}
					}
					break;
			}
			break;

		case "measure":
			imageData.svgName = "ruler";

			if (data.data?.points) {
				const points = SMap.Coords.stringToCoords(data.data.points);
				let distance = 0;

				for (let index = 0; index < points.length-1; index++) {
					distance += points[index].distance(points[index+1]);
				}

				const formatDistance = standardDistanceFormat(distance);

				imageData.customDesc = _("distanceMeter.module.subtitle", {
					count: points.length-1,
					section: points.length-1,
					distance: formatDistance ? formatDistance.string : "",
				});
			}
			break;

		case "path":
		case "measureRO":
			imageData.svgName = "custom-distance";
			imageData.imgSrc = "";
			// pro klikatko vyuzijeme toho, ze ta funkce vraci defaultni ikonu, kdyz dostane nesmysl jako parametr
			imageData.svg = () => createSDSIcon({ symbol: pathTypeToMapIcon(Mapy.CUS.mapybox?.pathTypes && data.data?.info?.trackType ? data.data?.info?.trackType : "") });
			break;

		case "set":
			imageData.svgName = "custom-points";

			if (data.data?.ut) {
				const count = data.data.ut.length;

				imageData.customDesc = _("userMarks.favouritePoint", {
					NUM: count,
					TXT: count,
				});
			}
			break;

		case "route":
			imageData.svgName = "car";

			if (data.data?.route) {
				const criterion = data.data.route[0].tripParams ? data.data.route[0].tripParams.criterion : data.data.route[0].routeParams ? data.data.route[0].routeParams.criterion : 111;
				const routeTypes = Object.keys(ROUTE_CONST.types);
				let routeType = routeTypes.filter(itemType => ROUTE_CONST.types[itemType].criterion.indexOf(criterion) > -1);

				// stare kriteria
				if (!routeType[0]) {
					routeType = routeTypes.filter(itemType => ROUTE_CONST.types[itemType].criterion.indexOf(replaceOldCriterion(criterion)) > -1);
				}
				if (routeType[0]) {
					imageData.svgName = `mymaps-route-${ROUTE_CONST.types[routeType[0]].svg}`;
				} else {
					imageData.svgName = "mymaps-route-car";
				}

				imageData.svg = () => createSDSIcon({ symbol: routeTypeToMapIcon(routeType[0] ? routeType[0] : "") });

				if (data.data.totalLength && data.data.totalTime) {
					const distance = standardDistanceFormat(data.data.totalLength);
					const time = standardTimeFormat(parseInt(data.data.totalTime), false).string;

					imageData.customDesc = _("mymap.places.route", { DIST: `${distance.string}`, TIME: time });
				}
			}

			break;

		case "track":
			imageData.svgName = "run";
			break;
		default:
			break;
	}

	if (!imageData.imgSrc && !imageData.svgName) {
		imageData.svgName = "star-line";
	}

	// funkce pro vytvoreni
	if (imageData.imgSrc) {
		imageData.img = () => {
			const image = new Image();

			image.crossOrigin = "anonymous";
			image.src = imageData.imgSrc;

			return image;
		};
	}

	if (imageData.svgName && !imageData.svg) {
		imageData.svg = () => icon(imageData.svgName);
	}

	return imageData;
}
